
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class WPFromTo extends Vue {
  @Prop({ default: ':' })
  public readonly delimiter?: string
}
